import { gql } from '@apollo/client';

export const UPDATE_USER_TOUR_STATUS = gql`
  mutation UpdateUserTourStatus(
    $operation: UserTourOperationEnum!
    $product: UserTourProductEnum!
  ) {
    updateUserTourStatus(operation: $operation, product: $product) {
      success
    }
  }
`;
